"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMoney = exports.getIDsToBadge = exports.convertToFloat = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/*
  Converts string numbers to float.
  e.g. '5,000' -> 5000.
  Unfortunately, parseFloat and `+` do not work for strings with comma.
*/
var convertToFloat = exports.convertToFloat = function convertToFloat(numString) {
  return typeof numString === 'number' ? numString : parseFloat(numString.replace(/,/g, ''));
};
var parseMoney = exports.parseMoney = function parseMoney(dollarAmountString) {
  return convertToFloat(dollarAmountString.startsWith('$') ? dollarAmountString.substring(1) : dollarAmountString);
};
var getLowestValues = function getLowestValues(offers, parse) {
  var lowestValues = [];
  var lowest = Number.MAX_SAFE_INTEGER;
  offers.forEach(function (offer) {
    var value = parse(offer);
    if (lowest > value) {
      // We have a new lowest value, hence overwrite.
      lowestValues = [offer.id];
      lowest = value;
    } else if (lowest === value) {
      // we have another lowest, so just add the id.
      lowestValues.push(offer.id);
    }
  });
  return lowestValues;
};
var getIDsToBadge = exports.getIDsToBadge = function getIDsToBadge(products) {
  var _products$0$offers;
  if (!products || !products.length) return {};
  var singleProductSingleOffer = products.length === 1 && ((_products$0$offers = products[0].offers) === null || _products$0$offers === void 0 ? void 0 : _products$0$offers.length) === 1;
  if (singleProductSingleOffer) return {};
  var isAmountEqual = products.every(function (product) {
    return product.amount === products[0].amount;
  });
  if (!isAmountEqual) return {};
  var allOffers = products.reduce(function (acc, product) {
    return [].concat((0, _toConsumableArray2.default)(acc), (0, _toConsumableArray2.default)(product.offers));
  }, []);
  var lowestPayments = getLowestValues(allOffers, function (offer) {
    return parseMoney(offer.monthlyPayment);
  });
  var lowestRates = getLowestValues(allOffers, function (offer) {
    return +offer.apr;
  });
  var lowestPaymentID = lowestPayments.length === 1 ? lowestPayments[0] : undefined;
  var lowestRateID = lowestRates.length === 1 ? lowestRates[0] : undefined;
  var lowestBothID = lowestPaymentID && lowestRateID && lowestPaymentID === lowestRateID ? lowestPaymentID : undefined;
  return {
    lowestPaymentID: lowestPaymentID,
    lowestRateID: lowestRateID,
    lowestBothID: lowestBothID
  };
};
